export default __webpack_public_path__ + "static/media/img-industry-healthcare.8300fb5c.svg";